import React, { useEffect, useState } from "react";
import { Get_Api } from "../ApiUrls";


const AllTestimonial = () => {
    const [AllTestimonial, setAllTestimonial] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const GetAllTestimonial = async () => {
        try {
            const response = await Get_Api(`api/admin/GetAllTestimonial`);
            setAllTestimonial(response?.data || []);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        GetAllTestimonial();
    }, []);

    const prevTestimonial = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? AllTestimonial.length - 1 : prevIndex - 1
        );
    };

    const nextTestimonial = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === AllTestimonial.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <div className="testimonial-container">
            <div className="testimonial-container2">
                <div className="testimonial-overlay">
                    <h2>Our Testimonial</h2>
                    {AllTestimonial.length > 0 ? (
                        <div className="testimonial-content">
                            <div className="testimonial-avatar">
                                <img
                                    src={AllTestimonial[currentIndex]?.Image || "/avatar-placeholder.png"}
                                    alt="User Avatar"
                                />
                            </div>
                            <div className="testimonial-text">
                                <p>“{AllTestimonial[currentIndex]?.Text}”</p>
                                <h4>{AllTestimonial[currentIndex]?.Name}</h4>
                            </div>
                        </div>
                    ) : (
                        <p>Loading testimonials...</p>
                    )}
                    {AllTestimonial.length > 1 && (
                        <>
                            <button className="prev-button" onClick={prevTestimonial}>‹</button>
                            <button className="next-button" onClick={nextTestimonial}>›</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AllTestimonial;
